import { Injectable } from '@angular/core';
import { AppSessionService } from '@shared/common/session/app-session.service';

import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionCheckerService } from 'abp-ng2-module';
@Injectable()
export class AuthRouteGuard  {
    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this._sessionService.user) {
            return false;
        }

        if (!route.data || !route.data['permission']) {
            return true;
        }

        var permission = route.data['permission'];
        if (Array.isArray(permission) && permission.some((x: string) => this._permissionChecker.isGranted(x))) {
            return true;
        } else if (this._permissionChecker.isGranted(route.data['permission'])) {
            return true;
        }

        this._router.navigate(['/access-denied']); // The User has no permissions to access this guarded component
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
}
